import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';

import { styles } from '../voucher/styles'; 
import Add from './add';
import Header from '../../partials/header'

// Component
class Discount extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isAddVoucher: false,
        } 
    }
    componentDidMount() {
        this.props.serviceBranchDispatch.getListBranch();
    }

    addNewVoucher = () => {
        this.setState({ isAddVoucher: !this.state.isAddVoucher })
    }
    createDone = () =>{
        this.setState({
            isAddVoucher: false
        }) 
    }
    render() { 
        const { classes, theme,t } = this.props;
        return (
            <div>
                <Header 
                    session= {t('sidebar_promotion')}
                    title = {t("discount_discount")}
                />
                {/* <div className={classes.frameTitle}>
                    <Typography variant="h4">{!this.state.isAddVoucher ? t("discount_discount") : t("discount_create_discount") }</Typography>
                </div> */}
                <Grid container spacing={0}>
                    <Grid item xs={12} md={12} sm={12}> 
                        <Add /> 
                    </Grid>
                </Grid>
            </div>
        );
    }
}

Discount.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};

const mapState = state => ({ 
});

const mapDispatch = dispatch => ({ 
    serviceBranchDispatch: dispatch.serviceBranch,
});

export default connect(mapState, mapDispatch)(translate('translations')(withStyles(styles, { withTheme: true })(Discount)));